// extracted by mini-css-extract-plugin
export var carousel = "PhotoGallery-module--carousel--81099";
export var carouselImage = "PhotoGallery-module--carouselImage--c7230";
export var galleryContent = "PhotoGallery-module--galleryContent--bec5b";
export var image = "PhotoGallery-module--image--e19eb";
export var images = "PhotoGallery-module--images--994af";
export var left = "PhotoGallery-module--left--e48a4";
export var modalCloseButton = "PhotoGallery-module--modalCloseButton--494d9";
export var modalImage = "PhotoGallery-module--modalImage--f3cea";
export var photoGallery = "PhotoGallery-module--photoGallery--28618";
export var returnButton = "PhotoGallery-module--returnButton--34306";
export var right = "PhotoGallery-module--right--d6ff4";